module.exports = __webpack_public_path__ + "assets/img/warrior-name-3253b525.png";